(function () {
  function initNativeVideo(root) {
    (root || document).querySelectorAll('[data-sbd-native-video]').forEach(function (section) {
      if (section.dataset.sbdReady === 'true') return;
      section.dataset.sbdReady = 'true';

      var trigger = section.querySelector('[data-sbd-video-trigger]');
      var player = section.querySelector('[data-sbd-video-player]');
      var card = section.querySelector('[data-sbd-video-card]');
      var src = section.dataset.videoSrc;
      var autoplayOnView = section.dataset.autoplayOnView !== 'false';
      var pauseOutOfView = section.dataset.pauseOutOfView !== 'false';
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var isInView = false;

      if (!trigger || !player || !card || !src) return;

      function preparePlayer() {
        player.muted = true;
        player.defaultMuted = true;
        player.playsInline = true;
        player.controls = false;
        player.setAttribute('muted', '');
        player.setAttribute('playsinline', '');

        if (!player.getAttribute('src')) {
          player.setAttribute('src', src);
          player.load();
        }
      }

      function playVideo(isManual) {
        preparePlayer();

        if (player.ended) {
          try { player.currentTime = 0; } catch (error) {}
        }

        player.hidden = false;
        card.classList.add('is-loading');
        trigger.disabled = true;

        var playPromise = player.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {
            card.classList.remove('is-loading');
            trigger.disabled = false;

            if (!isManual && !card.classList.contains('is-playing')) {
              player.hidden = true;
            }
          });
        }
      }

      function pauseVideo() {
        if (!player.paused && !player.ended) player.pause();
      }

      trigger.addEventListener('click', function () {
        playVideo(true);
      });

      player.addEventListener('playing', function () {
        card.classList.add('is-playing');
        card.classList.remove('is-loading');
        trigger.disabled = false;
      });

      player.addEventListener('pause', function () {
        card.classList.remove('is-loading');
        trigger.disabled = false;
      });

      player.addEventListener('error', function () {
        card.classList.remove('is-playing', 'is-loading');
        player.hidden = true;
        trigger.disabled = false;
      });

      if (autoplayOnView && !reducedMotion && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var wasInView = isInView;
            isInView = entry.isIntersecting && entry.intersectionRatio >= 0.35;

            if (isInView && !wasInView) {
              playVideo(false);
            } else if (pauseOutOfView && !isInView && entry.intersectionRatio <= 0.1) {
              pauseVideo();
            }
          });
        }, { threshold: [0, 0.1, 0.35, 0.65] });

        observer.observe(section);
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          pauseVideo();
        } else if (isInView && autoplayOnView && !reducedMotion) {
          playVideo(false);
        }
      });
    });
  }

  function initCampaignVideo(root) {
    (root || document).querySelectorAll('[data-sbd-campaign-video-root]').forEach(function (section) {
      if (section.dataset.sbdCampaignVideoReady === 'true') return;
      section.dataset.sbdCampaignVideoReady = 'true';

      var player = section.querySelector('[data-sbd-campaign-video]');
      var src = section.getAttribute('data-video-src') || '';
      var lazySources = player ? player.querySelectorAll('source[data-src]') : [];
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var isInView = false;
      var sourcePrepared = false;
      var videoFailed = false;

      if (!player || (!src && !lazySources.length)) return;

      player.muted = true;
      player.defaultMuted = true;
      player.playsInline = true;
      player.loop = true;
      player.controls = false;
      player.setAttribute('muted', '');
      player.setAttribute('playsinline', '');
      player.removeAttribute('controls');

      try { player.disablePictureInPicture = true; } catch (error) {}

      function prepareVideo() {
        if (sourcePrepared || videoFailed) return;
        sourcePrepared = true;

        if (lazySources.length) {
          Array.prototype.forEach.call(lazySources, function (source) {
            var sourceUrl = source.getAttribute('data-src');
            if (sourceUrl) {
              source.setAttribute('src', sourceUrl);
              source.removeAttribute('data-src');
            }
          });
        } else if (src) {
          player.setAttribute('src', src);
        }

        player.load();
      }

      function showPoster() {
        section.classList.remove('is-video-loading', 'is-video-playing');
      }

      function pauseVideo() {
        if (!player.paused && !player.ended) player.pause();
        showPoster();
      }

      function playVideo() {
        if (!isInView || document.hidden || reducedMotion || videoFailed) return;

        prepareVideo();
        section.classList.add('is-video-loading');

        var playPromise = player.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {
            section.classList.remove('is-video-loading');
          });
        }
      }

      player.addEventListener('playing', function () {
        if (!isInView || document.hidden) {
          pauseVideo();
          return;
        }

        section.classList.remove('is-video-loading');
        section.classList.add('is-video-playing');
      });

      player.addEventListener('waiting', function () {
        if (isInView) section.classList.add('is-video-loading');
      });

      player.addEventListener('loadeddata', function () {
        if (isInView && player.paused && !document.hidden) playVideo();
      });

      player.addEventListener('canplay', function () {
        if (isInView && player.paused && !document.hidden) playVideo();
      });

      player.addEventListener('error', function () {
        videoFailed = true;
        showPoster();
      });

      if (reducedMotion) return;

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var wasInView = isInView;
            isInView = entry.isIntersecting && entry.intersectionRatio >= 0.22;

            if (isInView && !wasInView) {
              playVideo();
            } else if (!isInView && entry.intersectionRatio <= 0.05) {
              pauseVideo();
            }
          });
        }, { threshold: [0, 0.05, 0.22, 0.5] });

        observer.observe(section);
        section._sbdCampaignVideoObserver = observer;
      } else {
        isInView = true;
        playVideo();
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          pauseVideo();
        } else if (isInView) {
          playVideo();
        }
      });
    });
  }

  function init(root) {
    initNativeVideo(root || document);
    initCampaignVideo(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target && event.target.querySelector('[data-sbd-campaign-video-root]');
    if (section && section._sbdCampaignVideoObserver) {
      section._sbdCampaignVideoObserver.disconnect();
    }
  });
})();
